/*
 * @Author: robinhu 664196660@qq.com
 * @Date: 2024-11-16 14:39:14
 * @LastEditors: robinhu 664196660@qq.com
 * @LastEditTime: 2024-11-19 18:44:14
 * @FilePath: /admin-h5-page/src/main.js
 * @Description: 程序入口
 */
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router/router";
import store from "./store/store";
import "@/assets/css/reset.scss";
import "@/assets/css/common.scss";
import util from "@/plugin/util";
import dict from "@/plugin/dict";
import axios from "@/plugin/axios";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import * as ElementPlusIconsVue from "@element-plus/icons-vue";
import hzButton from "@/components/button/hz-button";
import hzTable from '@/components/table/hz-table.vue'
import hzDialog from '@/components/hz-dialog.vue'
import "default-passive-events";

// import * as dd from '@/mock/mock'
if (process.env.NODE_ENV === 'development') {
  // require('@/mock/mock') -- 对上传功能有影响
}

window.util = util;
window.logObj = (obj) => {return (JSON.parse(JSON.stringify(obj)))}
let app = createApp(App);
app.config.globalProperties.$util = util;  // getCurrentInstance().appContext.config.globalProperties.util可在模板表达式中使用
app.config.globalProperties.$dict = dict; 
app.config.globalProperties.$http = axios; 
app.use(ElementPlus);


// 全局注册element icon
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}
app.component("hzButton", hzButton);
app.component("hzTable", hzTable);
app.component("hzDialog", hzDialog);

app.use(store).use(router).mount("#app");

/**
 * 这里是由管理员系统跳转过来快捷登录的操作，目的是为了把那边快捷登录的token传过来，然后放到localStorage中，然后刷页面，这边就不用登录了
 */
window.addEventListener("message", (event) => {
  if ( event.data.token ){
    //获取token 过期时间
    function getTokenObject(token) {
      //通过split()方法将token转为字符串数组,数组中的第二个字符进行解析
      return token
        ? JSON.parse(
            decodeURIComponent(
              escape(
                window.atob(
                  token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/")
                )
              )
            )
          )
        : null;
    }
    const user = event.data;
    localStorage.setItem("user", JSON.stringify(user));
    localStorage.setItem(
      "tokenExp",
      getTokenObject(user.token)?.exp || null
    );
    location.reload(true)
  }
  
}, false);
